module.exports = __webpack_public_path__ + "img/chuanzhitu.d1dac04a.png";